<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Company"
      text="Update Payroll Company"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localCompanyEmployee.company_uid"
              :items="[localCompanyEmployee.company]"
              item-text="name"
              item-value="id"
              disabled
              filled
              label="Payroll Company"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="startDateDisplay"
              label="Start date"
              outlined
              disabled
              class="disabled-background"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('endDateDisplay')"
                  data-vv-name="endDateDisplay"
                  data-vv-as="end date"
                  label="End date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localCompanyEmployee.end_date"
                no-title
                :min="localCompanyEmployee.start_date"
                @input="endDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployee: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        endDateMenu: false,
        localCompanyEmployee: null,
      }
    },
    computed:
      {
        startDateDisplay () {
          return this.localCompanyEmployee.start_date ? this.$moment(this.localCompanyEmployee.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
        },
        endDateDisplay () {
          return this.localCompanyEmployee.end_date ? this.$moment(this.localCompanyEmployee.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
        },
      },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localCompanyEmployee = { ...this.companyEmployee }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.hrisCompanyEmployees().update(this.companyEmployee.company_employee_uid, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.$emit('updated')

                this.setProgressing(false)
                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          end_date: this.localCompanyEmployee.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}
.disabled-background >>> .v-input__slot{
  background: #f0f0f0
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:4px
}
</style>
